const DOWNLOAD_APNA_APP_LINK =
	"https://play.google.com/store/apps/details?id=com.apnatime&ref=w&utm_source=google_sem_sitelink&utm_medium=cpc&utm_campaign=IN_Search_Employer_Hyderabad_Brand_Exact-vNov19&_branch_match_id=1068859424995524728&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXz9FLLMhL1EvO1w8xjSjzjazyDq5MAgDgGlw5HQAAAA%3D%3D";
export default DOWNLOAD_APNA_APP_LINK;
